export const env = {
  API_URL: import.meta.env.APP_API_URL,
  OPENPANEL_CLIENT_ID: import.meta.env.APP_OPENPANEL_CLIENT_ID,
  OPENPANEL_API_URL: import.meta.env.APP_OPENPANEL_API_URL,
};
